import { FormFields } from 'app/model/form-fields';

import { UpdateActivationDateFormModel } from './update-activation-date-form-model';

const UPDATE_ACTIVATION_DATE_FORM_FIELDS: FormFields<UpdateActivationDateFormModel> = {
    activationDate: 'activationDate',
    rightOfWithdrawalIsAgreed: 'rightOfWithdrawalIsAgreed',
};

export { UPDATE_ACTIVATION_DATE_FORM_FIELDS };
